require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();

require("channels");
window.moment = require("moment");
window.moment.locale("ru");
window.DateRangePicker = require("./daterangepicker");
try {
  require("datatables.net-bs")(window, $);
} catch (e) {}

require("packs/dataTables.pageLoadMore");

import utility from "../utility";
window.word_form = word_form;
import GoodOkDataRangePicker from "./daterangepicker_init";
window.GoodOkDataRangePicker = GoodOkDataRangePicker;
import dropdown from "./dropdown";
import full_text_tip from "../full_text_tip";
import custom_select from "../custom_select";
import StaticDataTableMarkupBuilder from "../datatable/static_data_table_markup_builder";
window.StaticDataTableMarkupBuilder = StaticDataTableMarkupBuilder;
import DataTableController from "../datatable/data_table_controller";
window.DataTableController = DataTableController;
import AdminDataTableController from "../datatable/AdminDataTableController";
window.AdminDataTableController = AdminDataTableController;
import FreePhonesTableController from "../datatable/free_phones/free_phones_controller";
window.FreePhonesTableController = FreePhonesTableController;

import AdminHotKey from "../adminland/admin_hot_key";
window.AdminSearckHotkeys = AdminHotKey;

import UIHelp from "./UIHelp";
window.UIHelp = UIHelp;

import PhoneValidator from "../packs/phone_validator";
window.PhoneValidator = PhoneValidator;

import LocalStorageFormReplacement from "../packs/local_storage_form";
window.LocalStorageFormReplacement = LocalStorageFormReplacement;

import SEOEvents from "../SEOEvents";
window.SEOEventsHandler = new SEOEvents(window.is_dev);

import Throbber from "../throbber";
window.throbber = new Throbber();

import FormChangeTracker from "./forms/formChangeTracker";
window.FormChangeTracker = FormChangeTracker;

window.toastr = require("toastr");
toastr.options = {
  closeButton: true,
  closeHtml: '<span class="cross"></span>',
  newestOnTop: true,
  progressBar: false,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  showDuration: "5000",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

$(document).on("ajax:before", "[data-remote]", () => {
  Turbolinks.clearCache();
});

/** Очищает данные о фильтрации в локальном хранилище
 * @returns {void}
 */
function clearGoodokTableFilters() {
  const currentUserMeta = document.querySelector('[name="current_user"]');

  // Очищаем действующие фильтры
  $(".active-filters-list-el").trigger("click");

  if (currentUserMeta && currentUserMeta.dataset.id) {
    localStorage.removeItem(`goodok_table_filters-${currentUserMeta.dataset.id}`);

    return;
  }

  Object.keys(localStorage).forEach(key => {
    if (key.startsWith("goodok_table_filters-")) {
      localStorage.removeItem(key);
    }
  });
}

document.addEventListener("click", event => {
  const menuItem = event.target.closest(".sidebar-menu-list-el");

  if (!menuItem) {
    return;
  }

  if (menuItem.dataset.turbolinks === "false") {
    clearGoodokTableFilters();
  }
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
window.os = navigator.platform.search(/MacIntel|Macintosh/) ? "win" : "mac";

$(document).on("keydown", function(event) {
  if ((os === "win" && event.keyCode == "17") || (os === "mac" && event.metaKey)) {
    window.cmd_pressed = true;
  }
});

$(document).on("keyup", function(event) {
  window.cmd_pressed = false;
});

import MenuStateChooser from "./menu_state_chooser";

if (window.innerWidth >= 760) {
  function documentReady() {
    window.MenuStateChooser = new MenuStateChooser();
  }
  document.addEventListener("DOMContentLoaded", documentReady);
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service_worker.js")
    .then(
      registration => {
        console.log("ServiceWorker registered: ", registration);
      },
      function(err) {
        console.log("ServiceWorker registration failed: ", err);
      }
    )
    .catch(function(err) {
      console.log(err);
    })
    .catch(function(error) {
      console.error(error);
    });
}
